import { styled } from '@mui/material';

export const Container = styled('div')({
  'div.header': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
});

export const Title = styled('span')({
  fontSize: 16,
  fontWeight: 400,
  color: 'var(--color-greyscale-800)',
});

export const SwitchContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',

  'span.switch-title': {
    fontSize: 14,
    fontWeight: 400,
    letterSpacing: 0,
  },
});
